// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Default chat container (normal mode) */
.chat-container {
  overflow: hidden;
  height: 620px; /* Responsive height for normal mode */
  width: min(90vw, 800px);           /* Responsive width cap */
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 5px;
  box-shadow: 0 8px 24px rgba(0,0,0,0.12);
}

/* Fullscreen chat container – no fixed height/width constraints */
.fullscreen-chat-container {
  overflow: hidden;
  background: #fff;
  border: none;
  border-radius: 0;
  box-shadow: none;
  /* width: 100vw;
  height: 100vh; */
}

/* User messages */
.user-message {
  align-self: flex-end;    /* Align to right */
}

/* Bot messages */
.bot-message {
  align-self: flex-start;  /* Align to left */
}

/* Wrapper for chat content */
.chat-inner {
  display: flex;
  flex-direction: column;
  height: 100%;
}


.chat-body {
  display: flex;
  flex-direction: column;
  height: calc(100% - 50px); /* Adjust based on header's height */
}
/* Chat header styling */
.chat-header {
  flex: 0 0 50px;
  background-color: #f8f8f8;
  border-bottom: 1px solid #ddd;
  padding: 0px 15px;
  position: sticky;
  top: 0;
  z-index: 10;
  display: flex;
  justify-content: space-between;
  align-items: center;
}



/* Chat messages area */
.chat-messages {
  flex-grow: 1;
  padding: 16px clamp(10px, 3vw, 28px);
  overflow-y: auto;
  background-color: #f5f5f5;
  width: auto;
}

/* Custom scrollbar (optional) */
.chat-messages::-webkit-scrollbar {
  width: 10px;
}

.chat-messages::-webkit-scrollbar-track {
  background: #f5f5f5;
}

.chat-messages::-webkit-scrollbar-thumb {
  background-color: #ccc;
  border-radius: 4px;
}

/* Chat input area */
/* Chat input area styling */
.chat-input {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-top: 1px solid #ddd;
  background-color: #fff;
}

/* Input wrapper takes full width */
.input-wrapper {
  flex: 1 1;
}

/* Buttons container for input (vertical stack) */
.chat-buttons {
  display: flex;
  flex-direction: column;
  margin-left: 8px;
  gap: 5px;
}

/* Minimized chat button */
.chat-minimized {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 9999;
}

/* Optional: Ensure header buttons have some right margin */
.header-buttons > button {
  margin-left: 5px;
}

.processing-message {
  font-size: 14px;
  color: #555;
  font-style: italic;
}

.processing-text {
  display: inline-block;
  animation: pulse 1.5s infinite;
}

/* Pulse animation for a fancy effect */
@keyframes pulse {
  0% { opacity: 1; }
  50% { opacity: 0.5; }
  100% { opacity: 1; }
}

/* Message bubble/card sizing - auto width up to 60% (WhatsApp-like) */
.message-card {
  display: inline-block;
  width: fit-content;
  max-width: 60%;
  word-wrap: break-word;
  overflow-wrap: anywhere;
}

/* Alignments for bubbles within rows */
.user-message {
  margin-left: auto; /* push to the right when possible */
}
.bot-message {
  margin-right: auto; /* keep to the left */
}

/* Ensure media elements scale nicely inside bubbles */
.message-card img,
.message-card video,
.message-card audio,
.message-card iframe {
  max-width: 100%;
}

/* Slightly larger PDF/iframe view in fullscreen */
.fullscreen-chat-container .message-card iframe {
  min-height: 60vh;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,yCAAyC;AACzC;EACE,gBAAgB;EAChB,aAAa,EAAE,sCAAsC;EACrD,uBAAuB,YAAY,yBAAyB;EAC5D,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA,kEAAkE;AAClE;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB;kBACgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,oBAAoB,KAAK,mBAAmB;AAC9C;;AAEA,iBAAiB;AACjB;EACE,sBAAsB,GAAG,kBAAkB;AAC7C;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB,EAAE,oCAAoC;AACjE;AACA,wBAAwB;AACxB;EACE,cAAc;EACd,yBAAyB;EACzB,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;;;AAIA,uBAAuB;AACvB;EACE,YAAY;EACZ,oCAAoC;EACpC,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;AACb;;AAEA,gCAAgC;AAChC;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA,mCAAmC;AACnC;EACE,SAAO;AACT;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,QAAQ;AACV;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;AACf;;AAEA,2DAA2D;AAC3D;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA,uCAAuC;AACvC;EACE,KAAK,UAAU,EAAE;EACjB,MAAM,YAAY,EAAE;EACpB,OAAO,UAAU,EAAE;AACrB;;AAEA,sEAAsE;AACtE;EACE,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA,uCAAuC;AACvC;EACE,iBAAiB,EAAE,oCAAoC;AACzD;AACA;EACE,kBAAkB,EAAE,qBAAqB;AAC3C;;AAEA,sDAAsD;AACtD;;;;EAIE,eAAe;AACjB;;AAEA,kDAAkD;AAClD;EACE,gBAAgB;AAClB","sourcesContent":["/* Default chat container (normal mode) */\n.chat-container {\n  overflow: hidden;\n  height: 620px; /* Responsive height for normal mode */\n  width: min(90vw, 800px);           /* Responsive width cap */\n  background: #fff;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  box-shadow: 0 8px 24px rgba(0,0,0,0.12);\n}\n\n/* Fullscreen chat container – no fixed height/width constraints */\n.fullscreen-chat-container {\n  overflow: hidden;\n  background: #fff;\n  border: none;\n  border-radius: 0;\n  box-shadow: none;\n  /* width: 100vw;\n  height: 100vh; */\n}\n\n/* User messages */\n.user-message {\n  align-self: flex-end;    /* Align to right */\n}\n\n/* Bot messages */\n.bot-message {\n  align-self: flex-start;  /* Align to left */\n}\n\n/* Wrapper for chat content */\n.chat-inner {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n\n.chat-body {\n  display: flex;\n  flex-direction: column;\n  height: calc(100% - 50px); /* Adjust based on header's height */\n}\n/* Chat header styling */\n.chat-header {\n  flex: 0 0 50px;\n  background-color: #f8f8f8;\n  border-bottom: 1px solid #ddd;\n  padding: 0px 15px;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n\n\n/* Chat messages area */\n.chat-messages {\n  flex-grow: 1;\n  padding: 16px clamp(10px, 3vw, 28px);\n  overflow-y: auto;\n  background-color: #f5f5f5;\n  width: auto;\n}\n\n/* Custom scrollbar (optional) */\n.chat-messages::-webkit-scrollbar {\n  width: 10px;\n}\n\n.chat-messages::-webkit-scrollbar-track {\n  background: #f5f5f5;\n}\n\n.chat-messages::-webkit-scrollbar-thumb {\n  background-color: #ccc;\n  border-radius: 4px;\n}\n\n/* Chat input area */\n/* Chat input area styling */\n.chat-input {\n  display: flex;\n  align-items: center;\n  padding: 12px 16px;\n  border-top: 1px solid #ddd;\n  background-color: #fff;\n}\n\n/* Input wrapper takes full width */\n.input-wrapper {\n  flex: 1;\n}\n\n/* Buttons container for input (vertical stack) */\n.chat-buttons {\n  display: flex;\n  flex-direction: column;\n  margin-left: 8px;\n  gap: 5px;\n}\n\n/* Minimized chat button */\n.chat-minimized {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  z-index: 9999;\n}\n\n/* Optional: Ensure header buttons have some right margin */\n.header-buttons > button {\n  margin-left: 5px;\n}\n\n.processing-message {\n  font-size: 14px;\n  color: #555;\n  font-style: italic;\n}\n\n.processing-text {\n  display: inline-block;\n  animation: pulse 1.5s infinite;\n}\n\n/* Pulse animation for a fancy effect */\n@keyframes pulse {\n  0% { opacity: 1; }\n  50% { opacity: 0.5; }\n  100% { opacity: 1; }\n}\n\n/* Message bubble/card sizing - auto width up to 60% (WhatsApp-like) */\n.message-card {\n  display: inline-block;\n  width: fit-content;\n  max-width: 60%;\n  word-wrap: break-word;\n  overflow-wrap: anywhere;\n}\n\n/* Alignments for bubbles within rows */\n.user-message {\n  margin-left: auto; /* push to the right when possible */\n}\n.bot-message {\n  margin-right: auto; /* keep to the left */\n}\n\n/* Ensure media elements scale nicely inside bubbles */\n.message-card img,\n.message-card video,\n.message-card audio,\n.message-card iframe {\n  max-width: 100%;\n}\n\n/* Slightly larger PDF/iframe view in fullscreen */\n.fullscreen-chat-container .message-card iframe {\n  min-height: 60vh;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
